import { Link } from "react-router";

import { t } from "i18next";

import { Box, Button, Stack, Typography } from "@mui/material";

import {
  katsastusBannerCardSx,
  katsastusBannerCtaButtonSx,
  katsastusBannerDesktopLogoWrapperSx,
  katsastusBannerLogoMobileSx,
  katsastusBannerLogoSx,
  katsastusBannerSectionSx,
  katsastusBannerSubtitleSx,
  katsastusBannerTextStackSx,
  katsastusBannerTitleSx,
  katsastusBannerWrapperSx
} from "@/src/pages/consumer/HomePage/components/HomePageKatsastusBanner/katsastusBannerStyles";

import { VehicleType } from "@/src/types/types";

import katsastusLogoDesktop from "@/assets/images/A-Katsastus_logo-square_transparent.webp";
import katsastusLogoMobile from "@/assets/images/A-Katsastus_logo-vaaka_transparent.webp";

const BANNER_KEY = "consumer.homePage.katsastusBanner";

const KATSASTUS_BANNER_BLOG_PATH =
  "/blog/myy-paremmalla-hinnalla-kuntotutkimus-helpottaa-autoliikkeen-ostopaatosta";

interface HomePageKatsastusBannerProps {
  vehicleType: VehicleType;
}

const HomePageKatsastusBanner = ({
  vehicleType
}: HomePageKatsastusBannerProps) => {
  if (vehicleType !== VehicleType.CAR) return null;

  return (
    <Box sx={katsastusBannerWrapperSx}>
      <Box sx={katsastusBannerSectionSx}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={[
            { alignItems: "center" },
            ...(Array.isArray(katsastusBannerCardSx)
              ? katsastusBannerCardSx
              : [katsastusBannerCardSx])
          ]}
        >
          <Box sx={katsastusBannerDesktopLogoWrapperSx}>
            <Box
              component="img"
              src={katsastusLogoDesktop}
              alt="A-Katsastus"
              sx={katsastusBannerLogoSx}
            />
          </Box>
          <Stack sx={katsastusBannerTextStackSx}>
            <Typography component="p" sx={katsastusBannerTitleSx}>
              {t(`${BANNER_KEY}.title`)}
            </Typography>
            <Typography component="p" sx={katsastusBannerSubtitleSx}>
              {t(`${BANNER_KEY}.subtitle`)}
            </Typography>
          </Stack>
          <Button
            component={Link}
            to={KATSASTUS_BANNER_BLOG_PATH}
            variant="outlined"
            color="primary"
            sx={katsastusBannerCtaButtonSx}
          >
            {t(`${BANNER_KEY}.ctaButton`)}
          </Button>
          <Box
            component="img"
            src={katsastusLogoMobile}
            alt="A-Katsastus"
            sx={katsastusBannerLogoMobileSx}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default HomePageKatsastusBanner;
